import 'core-js/stable';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import React from 'react';
import ReactDOM from 'react-dom/client';

// 应用的入口配置
console.log(process.env.SISYPHE_APP_PATH);
let App = require(process.env.SISYPHE_APP_PATH).default;

// 在控制台显示最后一次构建时间
console.log('');
console.log(
  `%c------------------ SISYPHE APP INFO: START ------------------`,
  'color: teal; font-size: 14px; font-weight: bold;'
);
console.log(
  `%clast build time: ${process.env.SISYPHE_BUILD_DATE}`,
  'color: teal;'
);
if (process.env.NODE_ENV === 'development') {
  console.log(`%cEnvironment variables`, 'color: teal;');
  console.log(`%c${JSON.stringify(process.env, null, 2)}`, 'color: teal;');
}
console.log(
  `%c------------------  SISYPHE APP INFO: END  ------------------`,
  'color: teal; font-size: 14px; font-weight: bold;'
);
console.log('');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement(App));
